export const environment = {
  production: true,
  
  apiUrl: "https://umyomedical.site/api_umyocards/public/api/"
};


